import { render, staticRenderFns } from "./commentReply.vue?vue&type=template&id=4030fff2&scoped=true&"
import script from "./commentReply.vue?vue&type=script&lang=js&"
export * from "./commentReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4030fff2",
  null
  
)

export default component.exports